function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fc7e0f",
  d: "M33.32,29.46a7.2,7.2,0,0,1-2.17,2.85,7.11,7.11,0,0,1-2.39,1.24,14.8,14.8,0,0,1-4.11.43H9.35a14.8,14.8,0,0,1-4.11-.43,7.19,7.19,0,0,1-4.57-4.1A13.34,13.34,0,0,1,0,24.64H0V9.35H0A13.31,13.31,0,0,1,.68,4.53,7.19,7.19,0,0,1,5.25.43,14.8,14.8,0,0,1,9.35,0h15.3a14.8,14.8,0,0,1,4.11.43,7.19,7.19,0,0,1,4.57,4.1A13.34,13.34,0,0,1,34,9.35v15.3A13.31,13.31,0,0,1,33.32,29.46Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.43,21.81a2.74,2.74,0,1,0,2.75,2.74A2.75,2.75,0,0,0,9.43,21.81ZM6.69,13.69v4a9.66,9.66,0,0,1,9.65,9.67h4A13.64,13.64,0,0,0,6.69,13.69Zm0-7v4A16.69,16.69,0,0,1,23.35,27.31h4A20.66,20.66,0,0,0,6.69,6.68Z"
});

function SvgRss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss);
export default __webpack_public_path__ + "static/media/rss.a8426059.svg";
export { ForwardRef as ReactComponent };